import React from 'react';

import { TextInput, TextInputProps, useMantineTheme } from '@mantine/core';
import { SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';

interface BubbleTextInputProps extends TextInputProps {
  smartAssistantVisualConfig: SmartAssistantVisualConfig;
}

export function BubbleTextInput({ smartAssistantVisualConfig, ...props }: BubbleTextInputProps) {
  const theme = useMantineTheme();

  const labelColor = theme.other.getReadableColor(smartAssistantVisualConfig.assistantMessageColor);
  const inputBackgroundColor = smartAssistantVisualConfig.conversationBackgroundColor;
  const inputTextColor = theme.other.getReadableColor(inputBackgroundColor);

  return (
    <TextInput
      styles={{
        label: {
          color: labelColor
        },
        input: {
          backgroundColor: inputBackgroundColor,
          borderColor: inputBackgroundColor,
          color: inputTextColor,
          '&:focus': {
            borderColor: labelColor
          }
        }
      }}
      {...props}
    />
  );
}
